import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { DeliverySet, DeliverySetSearchParam, ResponseTsvData } from '../models';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DeliverySetService {

  private path = '/delivery_sets';

  constructor(private http: AlloxApiService) { }

  public search(param: DeliverySetSearchParam) {
    return this.http.get<[]>(this.path + param.toURLQuery()).pipe(
      map(objs => objs.map(obj => new DeliverySet(obj)))
    );
  }

  public fetch(id: number) {
    return this.http.get(this.path + '/' + id).pipe(
      map(obj => new DeliverySet(obj))
    );
  }

  public post(item: DeliverySet) {
    const json = item.toJSON();
    return this.http.post(this.path, json);
  }

  public put(item: DeliverySet) {
    const json = item.toJSON();
    return this.http.put(this.path + '/' + item.id, json);
  }

  public putSchedule(items: DeliverySet[]) {
    const uItems = items.map(item => item.toUpdateScheduleItemJSON());
    return this.http.put(this.path + '/schedule', { update_items: uItems });
  }

  public deletes(items: DeliverySet[]) {
    const dItems = items.map(item => item.toDeleteItemJSON());
    return this.http.post(this.path + '/delete', { delete_items: dItems });
  }

  public batchPost(item: string) {
    return this.http.post(this.path + '/batch', { url: item });
  }

  /**
 * Returns TSV download information
 *
 * @remarks
 * This method communicates the TSV download API and returns the information necessary for download
 *
 * @param param Delivery Set Search Criteria
 * @returns TSV data and file name
 */
  public export(param: DeliverySetSearchParam) {
    const json = param.toJSON();
    return this.http.post(this.path + '/export', json).pipe(
      map(obj => new ResponseTsvData(obj))
    );
  }

}
